import { mapActions } from 'pinia';
import {
  useModalStore,
} from '@/stores';
import * as types from '@/lib/constants/store';
import { isExternalUrl } from '@/lib/utils/url';

export default {
  methods: {
    ...mapActions(useModalStore, [
      types.OPEN_MODAL,
      types.CLOSE_MODAL,
    ]),
    isNavigatingAway(url, requireConfirm = false, target = '_blank') {
      const isExternal = isExternalUrl(url);
      const modalType = 'ConfirmNavigateAwayModal';
      const self = this;
      if (isExternal && requireConfirm) {
        this[types.OPEN_MODAL]({
          id: modalType,
          type: modalType,
          onConfirm() {
            self[types.CLOSE_MODAL]({ id: modalType });
            window.open(url, target);
          },
        });
      }
      return isExternal;
    },
    handleAnchorNavigatingAwayClick(event) {
      const anchor = event.target.closest('a');
      if (anchor) {
        const { href, target } = anchor;
        if (this.isNavigatingAway(href, true, target)) {
          event.preventDefault();
        }
      }
    },
    handleViewModeAnchorClick(event) {
      if (this.mode === 'VIEW') {
        this.handleAnchorNavigatingAwayClick(event);
      }
    },
  },
};
